import { useLocation } from "react-router-dom";
import { Flex, theme } from "antd";

import { navPathToTitlesMap } from "functions/navFuncs";

const PageTitle = () => {
  const {
    token: { fontSizeHeading4, fontWeightStrong },
  } = theme.useToken();

  const { pathname: currentNavPath } = useLocation();
  const currentNavTitles = navPathToTitlesMap[currentNavPath];
  return (
    <>
      <Flex className="page-title" gap="small" align="center">
        {currentNavTitles.map((title, index) => {
          const customStyle =
            index === currentNavTitles.length - 1
              ? { color: "#0c1f57" }
              : { color: "#01bbec" };
          const separator =
            index === currentNavTitles.length - 1 ? null : " > ";
          return (
            <span
              key={index}
              style={{
                fontSize: fontSizeHeading4,
                fontWeight: fontWeightStrong,
                ...customStyle,
              }}
            >
              {title}
              {separator}
            </span>
          );
        })}
      </Flex>
    </>
  );
};

export default PageTitle;
